import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import AltIcon from '../../Icons/AltIcon';
import CircleTakeIcon from '../../Icons/CircleTakeIcon';
import { circleComp } from '../../RecordingSessionEditor/redux/compThunks';
import { selectCompById } from '../../RecordingSessionEditor/redux/selectors';

type Props = {
    sessionId: string
    episodeId: string
    compId: string
}

export default function CircleComp({ sessionId, episodeId, compId }: Props) {
    const dispatch = useAppDispatch();
    const comp = useAppSelector(state => selectCompById(state, compId));

    const circled = comp?.circled ?? false;
    const alt = comp?.alt ?? false;

    const handleCircleClick = () => {
        if (!compId || !comp) return;
        dispatch(circleComp({ sessionId, episodeId, compId }));
    }

    return (
        <Tooltip title='Whether this comp is circled or marked as an alt'>
            <IconButton
                aria-label='Circle take'
                onClick={handleCircleClick}
            >
                <>
                    {circled && <CircleTakeIcon />}
                    {alt && <AltIcon />}
                    {!circled && !alt && <CircleTakeIcon gray />}
                </>
            </IconButton>
        </Tooltip>
    )
}